import amplitude from 'amplitude-js'
import { AMPLITUDE_KEY, BI_DOMAIN } from '@constants'
import { safeStorageGet } from '@utils'

export const initBI = (userId: string, callback: (key: string) => void) => {
  if (!BI_DOMAIN) return
  amplitude
    .getInstance('BI')
    .init(AMPLITUDE_KEY, userId, { apiEndpoint: BI_DOMAIN }, () =>
      callback('BI'),
    )
}

export const sendBIData = (eventType: string, eventParams: object) => {
  const checkInit = setInterval(() => {
    if (safeStorageGet('BIInit') === 'true') {
      amplitude.getInstance('BI').logEvent(eventType, eventParams)
      clearInterval(checkInit)
    }
  }, 500)
}

export const setBIUserId = (userId: string) => {
  const checkInit = setInterval(() => {
    if (safeStorageGet('BIInit') === 'true') {
      amplitude.getInstance('BI').setUserId(userId)
      clearInterval(checkInit)
    }
  }, 500)
}
